module.exports = __webpack_public_path__ + "static/media/my-course.4a74d166.svg";